/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LoyaltyPremiumStatusQueryVariables = Exact<{ [key: string]: never }>;

export type LoyaltyPremiumStatusQuery = {
  readonly loyaltyProfile: {
    readonly customerId: string;
    readonly rewardsPremiumStatus: {
      readonly expirationDate: string;
      readonly isActive: boolean;
    } | null;
  } | null;
};

export const LoyaltyPremiumStatusDocument = gql`
  query LoyaltyPremiumStatus {
    loyaltyProfile {
      customerId
      rewardsPremiumStatus {
        expirationDate
        isActive
      }
    }
  }
`;

export function useLoyaltyPremiumStatusQuery(
  options?: Omit<Urql.UseQueryArgs<LoyaltyPremiumStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LoyaltyPremiumStatusQuery, LoyaltyPremiumStatusQueryVariables>({
    query: LoyaltyPremiumStatusDocument,
    ...options,
  });
}
